import React from 'react'
import List from '../components/List'
import hipladeTemplate from '../../common/template'

function EventsList() {
  return <List />
}

export default hipladeTemplate(EventsList)
